import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import IosShareIcon from '@mui/icons-material/IosShare';
import CategoryIcon from '@mui/icons-material/Category';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import GavelIcon from '@mui/icons-material/Gavel';

const mainListItems = [
    {text: 'Finanzstatus', icon: <AccountBalanceWalletIcon/>, path: '/'},
    {text: 'Karten', icon: <CreditCardIcon/>, path: '#'},
    {text: 'Aufträge', icon: <IosShareIcon/>, path: '#'},
    {text: 'Produkte', icon: <CategoryIcon/>, path: '#'},
];

const secondaryListItems = [
    {text: 'Hilfe', icon: <ContactSupportIcon/>, path: '#'},
    {text: 'Rechtliches', icon: <GavelIcon/>, path: '#'},
];

export default function MenuContent({ selected }) {
    return (
        <Stack sx={{flexGrow: 1, p: 1, justifyContent: 'space-between'}}>
            <List dense>
                {mainListItems.map((item, index) => (
                    <ListItem key={item.text} disablePadding sx={{display: 'block'}}>
                        <ListItemButton selected={index === selected} href={item.path}>
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <ListItemText primary={item.text}/>
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
            <List dense>
                {secondaryListItems.map((item) => (
                    <ListItem key={item.text} disablePadding sx={{display: 'block'}}>
                        <ListItemButton href={item.path}>
                            <ListItemIcon>{item.icon}</ListItemIcon>
                            <ListItemText primary={item.text}/>
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Stack>
    );
}